import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import { PriceAbs, PricePerc } from "../product-price";
import CircleInfo from "../../icons/circle-info-light.svg";
import { isTagRedOrBlue } from "../../utility/campaign-manager";
import Parser from "html-react-parser";

const Discount = ({
  price,
  priceLanguage,
  priceAbs,
  labelManagerLabels,
  config,
  priceWithWeee,
  contributoRaee,
}) => {
  return (
    <>
      <span className="product-price__saving d-inline-flex align-items-center">
        {priceAbs ? (
          <span>
            {config?.tagTextPosition === "Before value" && labelManagerLabels?.save && (
              <span className="ml-1">{labelManagerLabels?.save}&nbsp;</span>
            )}
            <PriceAbs
              priceLanguage={priceLanguage}
              data={price}
              save={labelManagerLabels?.save && true}
              priceWithWeee={priceWithWeee}
              contributoRaee={contributoRaee}
              origin="tag"
            />
            {config?.tagTextPosition === "After value" && labelManagerLabels?.save && (
              <span className="ml-1">&nbsp;{labelManagerLabels?.save}</span>
            )}
          </span>
        ) : (
          <>
            <span>
              {config?.tagTextPosition === "Before value" && labelManagerLabels?.save && (
                <span className="ml-1">{labelManagerLabels?.save}&nbsp;</span>
              )}
              <PricePerc
                priceLanguage={priceLanguage}
                data={price}
                save={labelManagerLabels?.save && true}
                priceWithWeee={priceWithWeee}
                contributoRaee={contributoRaee}
                origin="tag"
              />
              {config?.tagTextPosition === "After value" && labelManagerLabels?.save && (
                <span className="ml-1">&nbsp;{labelManagerLabels?.save}</span>
              )}
            </span>
            {labelManagerLabels?.pricePercentageTooltip && (
              <>
                <p data-for="priceInPercInfo" data-tip>
                  <CircleInfo className="product-price__icon" />
                </p>
                <ReactTooltip
                  id="priceInPercInfo"
                  place="bottom"
                  effect="float"
                  textColor="#505456"
                  type="light"
                >
                  <CircleInfo className="product-price__icon product-price__icon--tooltip" />{" "}
                  {Parser(labelManagerLabels?.pricePercentageTooltip)}
                </ReactTooltip>
              </>
            )}
          </>
        )}
      </span>
      <div id="absolute" className="d-none">
        <span>
          {config?.tagTextPosition === "Before value" && labelManagerLabels?.save && (
            <span className="ml-1">{labelManagerLabels?.save}&nbsp;</span>
          )}
          <PriceAbs
            priceLanguage={priceLanguage}
            data={price}
            save={labelManagerLabels?.save && true}
            priceWithWeee={priceWithWeee}
            contributoRaee={contributoRaee}
            origin="tag"
          />
          {config?.tagTextPosition === "After value" && labelManagerLabels?.save && (
            <span className="ml-1">&nbsp;{labelManagerLabels?.save}</span>
          )}
        </span>
      </div>
      <div id="perc" className="d-none">
        <>
          <span>
            {config?.tagTextPosition === "Before value" && labelManagerLabels?.save && (
              <span className="ml-1">{labelManagerLabels?.save}&nbsp;</span>
            )}
            <PricePerc
              priceLanguage={priceLanguage}
              data={price}
              save={labelManagerLabels?.save && true}
              priceWithWeee={priceWithWeee}
              contributoRaee={contributoRaee}
              origin="tag"
            />
            {config?.tagTextPosition === "After value" && labelManagerLabels?.save && (
              <span className="ml-1">&nbsp;{labelManagerLabels?.save}</span>
            )}
          </span>
          {labelManagerLabels?.pricePercentageTooltip && (
            <>
              <p data-for="priceInPercInfo" data-tip>
                <CircleInfo className="product-price__icon" />
              </p>
              <ReactTooltip
                id="priceInPercInfo"
                place="bottom"
                effect="float"
                textColor="#505456"
                type="light"
              >
                <CircleInfo className="product-price__icon product-price__icon--tooltip" />{" "}
                {Parser(labelManagerLabels?.pricePercentageTooltip)}
              </ReactTooltip>
            </>
          )}
        </>
      </div>
    </>
  );
};

const ProductTag = ({ data, className, location, contributoRaee }) => {
  const {
    site: {
      siteMetadata: { priceLanguage },
    },
    config,
    labelManagerLabels,
  } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            priceLanguage
          }
        }
        config: liferayGeneralConfiguration {
          tagvalue
          tagColor
          tagTextPosition
          priceWithWeee
        }
        labelManagerLabels: labelManagerLabels {
          pricePercentageTooltip
          save
        }
      }
    `
  );

  const contributoRaeeVal = contributoRaee
    ? parseFloat(contributoRaee?.replace(/[^0-9,.]/g, "")?.replace(/[^0-9]/g, "."))?.toFixed(2)
    : null;

  const priceAbs = config.tagvalue === "Absolute";

  const tagLabel = data.productTag ? data.productTag : data?.taxonomyCategoryBriefs?.[0]?.name;
  let color = data.price
    ? config.tagColor?.toLowerCase()
    : data.productTag
    ? data?.color[0]
      ? data.color[0]
      : "blu"
    : data?.colorCategory[0]
    ? data.colorCategory[0]
    : "blu";

  if (isTagRedOrBlue(location) && data.price) {
    color = config?.tagColor?.toLowerCase() === "red" ? "blu" : "red";
  }

  return (
    <div
      className={
        data?.colorHexa
          ? classNames("prodotti__tag", className)
          : classNames(
              "prodotti__tag",
              {
                "prodotti__tag--light-grey": color === "light grey",
                "prodotti__tag--grey": color === "grey",
                "prodotti__tag--red": color === "red",
                "prodotti__tag--blue": color === "blu",
              },
              className
            )
      }
      style={{ backgroundColor: data?.colorHexa, color: data?.colorHexaText }}
    >
      {data.price ? (
        <Discount
          price={data.price}
          priceLanguage={priceLanguage}
          priceAbs={priceAbs}
          labelManagerLabels={labelManagerLabels}
          config={config}
          priceWithWeee={config?.priceWithWeee}
          contributoRaee={contributoRaeeVal}
        />
      ) : (
        <span>{tagLabel}</span>
      )}
    </div>
  );
};

export default React.memo(ProductTag);
